var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientsList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 50,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9137 23.0008C34.1758 22.1414 35.0007 20.7424 35.0007 19.158C35.0007 16.543 32.7618 14.4231 30 14.4231C27.2382 14.4231 24.9993 16.543 24.9993 19.158C24.9993 20.7424 25.8242 22.1414 27.0863 23.0008C23.5463 23.969 21 26.6498 21 29.8077H39C39 26.6498 36.4537 23.969 32.9137 23.0008Z",
    fill: "black",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9137 26.8473C28.1758 25.9878 29.0007 24.5888 29.0007 23.0044C29.0007 20.3894 26.7618 18.2695 24 18.2695C21.2382 18.2695 18.9993 20.3894 18.9993 23.0044C18.9993 24.5888 19.8242 25.9878 21.0863 26.8473C17.5463 27.8155 15 30.4962 15 33.6541H33C33 30.4962 30.4537 27.8155 26.9137 26.8473Z",
    fill: "black",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsList);
export default __webpack_public_path__ + "static/media/Clients_list.27bf783a9ac19dd15611b22b183cdd15.svg";
export { ForwardRef as ReactComponent };